<template>
  <div :class="[classes.stakeFixedWrapper, layoutClass]">
    <DynamicText
      tag="div"
      styleGroup="Stake Text"
      :get="stakeFixedStyle.get"
      :set="stakeFixedStyle.set"
      :class="[classes.stakeText, layoutClass]"
    >
      {{ stakeText }}
    </DynamicText>
    <DynamicText
      tag="div"
      styleGroup="Stake Amount"
      :get="stakeAmountStyle.get"
      :set="stakeAmountStyle.set"
      :class="[classes.stakeAmount, layoutClass]"
    >
      {{ formattedStake }}
    </DynamicText>
  </div>
</template>

<script lang="ts">
import { Brand } from "@fresh8/types/src";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, defineComponent } from "vue";
import { useStake } from "@fresh8/ad-data-composition/src/usePotentialWinnings";
import { getPotentialWinningsTranslations } from "../lib/language";
import DynamicText from "./DynamicText.vue";
import {
  injectTemplateSize,
  LARGE_MPU,
  SKYSCRAPER,
  MOBILE_LEADERBOARD,
  LEADERBOARD,
  LARGE_LEADERBOARD,
  LMLB
} from "@fresh8/ad-data-composition/src/useTemplateSize";

const useStyles = createUseStyles({
  stakeFixedWrapper: {
    display: "flex",
    flexFlow: props => props.flexFlow,
    alignItems: "center",
    border: props => props.border,

    [`&.${LARGE_MPU.name}`]: {
      height: "84px"
    },

    [`&.${SKYSCRAPER.name}`]: {
      height: "76px"
    },

    [`&.${MOBILE_LEADERBOARD.name}`]: {
      width: "51px",
      height: "14px"
    },

    [`&.${LMLB.name}`]: {
      width: "51px",
      height: "14px"
    },

    [`&.${LEADERBOARD.name}`]: {
      maxWidth: "128px",
      height: "44px"
    },

    [`&.${LARGE_LEADERBOARD.name}`]: {
      maxWidth: "128px",
      height: "44px"
    }
  },
  stakeText: {
    fontSize: "12px",
    marginRight: "5px",

    [`&.${LARGE_MPU.name}`]: {
      fontSize: "14px"
    },

    [`&.${SKYSCRAPER.name}`]: {
      fontSize: "14px"
    },

    [`&.${MOBILE_LEADERBOARD.name}`]: {
      fontSize: "5px",
      lineHeight: "7px",
      display: "flex",
      justifyContent: "center",
      width: "100%",
      background: "#E1E3EB",
      marginRight: "0px"
    },

    [`&.${LEADERBOARD.name}`]: {
      fontSize: "14px",
      marginRight: "6px"
    },

    [`&.${LARGE_LEADERBOARD.name}`]: {
      fontSize: "14px",
      marginRight: "6px"
    }
  },
  stakeAmount: {
    fontSize: "15px",

    [`&.${LARGE_MPU.name}`]: {
      fontSize: "20px"
    },

    [`&.${SKYSCRAPER.name}`]: {
      fontSize: "20px"
    },

    [`&.${MOBILE_LEADERBOARD.name}`]: {
      fontSize: "8px",
      lineHeight: "8px"
    },

    [`&.${LMLB.name}`]: {
      fontSize: "8px",
      lineHeight: "8px"
    },

    [`&.${LEADERBOARD.name}`]: {
      fontSize: "18px"
    },

    [`&.${LARGE_LEADERBOARD.name}`]: {
      fontSize: "18px"
    }
  }
});

export default defineComponent({
  name: "StakeFixed",
  components: {
    DynamicText
  },
  setup() {
    const stake = getPotentialWinningsTranslations();
    const templateContext = injectTemplateSize();

    const { formattedStake } = useStake();

    const layoutClass = computed(() => templateContext.size.value.name);
    const classes = useStyles(
      computed(() => ({
        flexFlow:
          layoutClass.value === MOBILE_LEADERBOARD.name ? "column" : "row",
        border:
          layoutClass.value === MOBILE_LEADERBOARD.name
            ? "1px solid #E1E3EB"
            : ""
      }))
    );

    return {
      classes,
      stakeText: stake,
      formattedStake,
      stakeFixedStyle: {
        get: (brand: Brand) => brand.adTemplate.potentialWinnings.stakeFont,
        set: (brand: Brand, value: string) =>
          (brand.adTemplate.potentialWinnings.stakeFont = value)
      },
      stakeAmountStyle: {
        get: (brand: Brand) =>
          brand.adTemplate.potentialWinnings.stakeAmountFont,
        set: (brand: Brand, value: string) =>
          (brand.adTemplate.potentialWinnings.stakeAmountFont = value)
      },
      layoutClass: computed(() => templateContext.size.value.name)
    };
  }
});
</script>
